import prescriptionsServices from '@/services/prescriptions.services.js';
import mixin from '@/mixin/index.js';
const {
    _getMessage,
    _getLabel,
    _removeAccents,
} = mixin.methods;
const root = { root: true };
let prescriptionInitializationSequence = 0;
const normalizePrescriptionPage = (payload) => {
    if (Array.isArray(payload)) {
        return { items: payload, nextCursor: null, hasMore: false };
    }
    return {
        items: (payload && payload.items) || [],
        nextCursor: (payload && payload.nextCursor) || null,
        hasMore: !!(payload && payload.hasMore),
    };
};
const prescriptionErrorAction = (dispatch, showError = true) => (error) => {
    if (showError) dispatch('general/showError', null, root);
    return { ok: false, error };
};
const addFreeTextDrugNode = (children, args) => {
    const [firstChild, ...followingChildren] = children;

    return {
        type: 1,
        sections: [
            { style: 2, text: _getLabel('ADD_FREE_TEXT') },
            {
                style: 3,
                text: "Com o texto livre você pode adicionar um medicamento que você não encontrou na lista ou deseja customizar.",
            }, {
                style: 3,
                text: "Preencha os detalhes abaixo para incluir o item manualmente.",
            }
        ],
        child: {
            type: 3,
            question: "Digite o nome e a apresentação do medicamento desejado:",
            inputs: [
                {
                    rule: (v) => !!v || _getMessage('REQUIRED_FIELD'),
                    model: "freeTextNameDisplay",
                    kind: "textfield",
                    placeholder: "Ex: Dipirona Comprimido 500 mg"
                }
            ],
            child: firstChild ? nodes[firstChild](followingChildren, args) : null
        }
    };
}
const routeNode = (children, args) => {
    const [firstChild, ...followingChildren] = children;
    return {
        type: 3,
        question: "Qual a via de administração? (Opcional)",
        child: firstChild ? nodes[firstChild](followingChildren, args) : null,
        inputs: [{
            rule: true,
            model: "route",
            kind: "textfield",
            placeholder: "Ex: Oral"
        }],
    }
}
const drugOptionNode = (children, args) => {
    const [firstChild, ...followingChildren] = children;
    const options = args.options.map(({ name, option }) => ({
        title: `${name} ${option.concentration}${option.unit} - ${option.display}`,
        child: firstChild ? nodes[firstChild](followingChildren, args) : null,
    }));

    return {
        type: 2,
        question: "Qual apresentação você deseja prescrever?",
        options,
        model: "display"
    }
}
const doseSelectionNode = (children, args) => {
    const [firstChild, ...followingChildren] = children;
    const options = args.doses.map(({ description, title }) => {
        const subtitle = description;

        return {
            subtitle,
            title: title,
            child: firstChild ? nodes[firstChild](followingChildren, args) : null,
        }
    });

    return {
        type: 2,
        question: "Qual dose você deseja utilizar?",
        options,
        model: "dose",
    }
}
const posologyNode = (children, args) => {
    let [firstChild, ...followingChildren] = children;
    return {
        type: 3,
        question: "Qual a posologia para esta prescrição?",
        inputs: [
            {
                rule: (v) => !!v || _getMessage('REQUIRED_FIELD'),
                model: "posology",
                kind: "textfield",
                placeholder: "Ex: 1 comprimido a cada 12 horas por 3 dias."
            }
        ],
        child: {
            type: 3,
            question: "Informações adicionais: (Opcional)",
            inputs: [
                {
                    rule: true,
                    model: "additionalInformation",
                    kind: "textfield",
                    placeholder: "Ex: Evite administrar em jejum."
                }
            ],
            child: !firstChild ? null : nodes[firstChild](followingChildren, args)
        }
    }
}
const quantityNode = (children, args) => {
    let [firstChild, ...followingChildren] = children;
    return {
        type: 3,
        question: "Qual a quantidade para esta prescrição? (Opcional)",
        inputs: [
            {
                rule: true,
                model: "quantity",
                kind: "textfield",
                placeholder: "Ex: 1 caixa"
            }
        ],
        child: !firstChild ? null : nodes[firstChild](followingChildren, args)
    }
}
const pageNode = (children, args) => {
    const [firstChild, ...followingChildren] = children;

    const { pages } = args;
    if (!pages || pages == 0) return !firstChild ? null : nodes[firstChild](followingChildren, args);
    let options = [];
    for (let page = 0; page < pages; page++) {
        options.push({
            title: `${_getLabel("TAB_GUIDE")} ${parseInt(page) + 1}`,
            child: firstChild ? nodes[firstChild](followingChildren, args) : null,
        })
    }
    if (options.length < 4) {
        options.push({
            title: "Adicionar em nova guia",
            child: firstChild ? nodes[firstChild](followingChildren, args) : null,
        })
    }

    return {
        type: 2,
        question: "Em qual guia você deseja adicionar este medicamento?",
        options,
        model: "page"
    }
}
const prescriptionsRegistrationAlgorithm = (child) => {
    return {
        type: 1,
        sections: [
            { style: 2, text: "Boas vindas ao módulo de prescrição!" },
            {
                style: 3,
                text: "Para começar, precisaremos completar o seu cadastro",
            },
            {
                style: 3,
                text: "Caso queira saber mais sobre este recurso entre em contato conosco.",
            },
        ],
        child,
    };
}
const nodes = {
    addFreeTextDrugNode,
    drugOptionNode,
    doseSelectionNode,
    routeNode,
    posologyNode,
    quantityNode,
    pageNode
};
const ADD_EDIT_NODES = [
    "posologyNode",
    "pageNode",
    "routeNode",
    "quantityNode",
];
const ADD_EDIT_FREE_TEXT_NODES = [
    "addFreeTextDrugNode",
    "posologyNode",
    "pageNode",
    "routeNode",
    "quantityNode",
];
const EDIT_MODELS = [
    "dose",
    "posology",
    "additionalInformation",
    "option",
    "route",
    "page",
    "quantity",
];
const EDIT_FREE_TEXT_MODELS = [
    "posology",
    "additionalInformation",
    "quantity",
    "route",
    "page",
    "freeTextNameDisplay",
];
const COMPLETE_REGISTRATION_MODELS = [
    "displayName",
    "displayNamePrefix",
    "cpf",
    "crmvState",
    "crmvNumber",
    "nationality",
    "addressZipCode",
    "addressStreet",
    "addressNumber",
    "addressComplement",
    "addressNeighborhood",
    "addressCity",
    "addressState"
];
const getNodesFromNames = (names, args) => {
    const [firstChild, ...followingChildren] = names;
    return firstChild ? nodes[firstChild](followingChildren, args) : null;
}
const getUserArgs = (user) => {
    return {
        ...user,
        nationality: 0,
        addressZipCode: user.address ? user.address.zipCode : null,
        addressStreet: user.address ? user.address.street : null,
        addressNumber: user.address ? user.address.number : null,
        addressComplement: user.address ? user.address.complement : null,
        addressNeighborhood: user.address ? user.address.neighborhood : null,
        addressCity: user.address ? user.address.city : null,
        addressState: user.address ? user.address.state : null
    }
}
export default {
    async fetchEncounterPrescriptionsAction(
        { dispatch, commit, state },
        { patientId, encounterId, cursor = null, append = false, showError = true } = {}
    ) {
        if (!patientId || !encounterId) return { ok: false, error: null };
        return await dispatch('general/loadingHandler', {
            logEventArgs: 'fetchEncounterPrescriptions',
            action: async () => {
                const payload = await prescriptionsServices.getPrescriptions(
                    patientId,
                    cursor,
                    { encounterId, pagination: 'v2' }
                );
                const page = normalizePrescriptionPage(payload);
                if (state.patientId === patientId && state.encounterId === encounterId) {
                    const currentItems = append ? state.contextPrescriptions || [] : [];
                    const itemsById = new Map(currentItems.map(item => [item.id, item]));
                    page.items.forEach(item => itemsById.set(item.id, item));
                    commit('setContextPrescriptions', {
                        items: Array.from(itemsById.values()),
                        nextCursor: page.nextCursor,
                        hasMore: page.hasMore
                    });
                }
                return { ok: true, data: page };
            },
            errorAction: prescriptionErrorAction(dispatch, showError)
        }, root);
    },
    async initializeEncounterPrescriptionAction(
        { dispatch, commit },
        {
            patientId = null,
            encounterId = null,
            prescriptionId = null,
            prescription = null,
            readonly = false,
            preserveContextList = false,
            showError = true
        } = {}
    ) {
        const initializationId = ++prescriptionInitializationSequence;
        if (!preserveContextList) {
            commit('resetPrescriptionState');
            commit('setPrescriptionContext', { patientId, encounterId, readonly });
        }
        try {
            let resolved = prescription
                ? {
                    ...prescription,
                    id: prescription.id || prescriptionId || null,
                    patientId: Object.prototype.hasOwnProperty.call(prescription, 'patientId')
                        ? prescription.patientId
                        : patientId || null,
                    encounterId: Object.prototype.hasOwnProperty.call(prescription, 'encounterId')
                        ? prescription.encounterId
                        : encounterId || null
                }
                : null;
            if (prescriptionId && !resolved) {
                resolved = await prescriptionsServices.getPrescriptionById(prescriptionId);
            }
            if (initializationId !== prescriptionInitializationSequence) {
                return { ok: false, data: null, error: null, cancelled: true };
            }
            const resolvedPatientId = patientId || (resolved && resolved.patientId) || null;
            if (patientId && resolved && resolved.patientId !== patientId) {
                throw new Error('A receita informada pertence a outro paciente.');
            }
            if (encounterId && resolved && resolved.encounterId !== encounterId) {
                throw new Error('A receita informada pertence a outra consulta.');
            }
            if (resolvedPatientId) {
                const selected = await dispatch('patients/selectPatientById', resolvedPatientId, root);
                if (initializationId !== prescriptionInitializationSequence) {
                    return { ok: false, data: null, error: null, cancelled: true };
                }
                if (!selected || !selected.ok) throw new Error('Não foi possível carregar o paciente da receita.');
                commit('setPrescriptionContext', {
                    patientId: resolvedPatientId,
                    encounterId: encounterId || (resolved && resolved.encounterId) || null,
                    readonly: readonly || !!(resolved && resolved.shareDate)
                });
            }
            if (resolved && preserveContextList) commit('clearActivePrescription');
            if (resolved) commit('hydratePrescription', resolved);

            if (resolvedPatientId && encounterId && !prescriptionId) {
                const linked = await dispatch('fetchEncounterPrescriptionsAction', {
                    patientId: resolvedPatientId,
                    encounterId,
                    showError: false
                });
                if (initializationId !== prescriptionInitializationSequence) {
                    return { ok: false, data: null, error: null, cancelled: true };
                }
                if (linked && linked.ok) {
                    // Uma consulta pode ter mais de uma receita. A escolha e
                    // feita no construtor; selecionar a primeira aqui faria o
                    // usuario editar/enviar o documento errado silenciosamente.
                    if (!resolved && (linked.data.items.length > 1 || linked.data.hasMore)) {
                        commit('setContextSelectionRequired', true);
                    } else if (!resolved && linked.data.items.length === 1) {
                        // Mantém o comportamento existente para consultas que
                        // ainda têm uma única receita vinculada.
                        resolved = linked.data.items[0];
                        commit('hydratePrescription', resolved);
                    }
                } else if (!resolved) {
                    throw (linked && linked.error) || new Error('Não foi possível carregar as receitas da consulta.');
                }
            }
            if (resolved) commit('setContextSelectionRequired', false);
            commit('setPrescriptionInitialized', true);
            return {
                ok: true,
                data: {
                    prescription: resolved,
                    patientId: resolvedPatientId,
                    encounterId: encounterId || (resolved && resolved.encounterId) || null,
                    readonly
                },
                error: null
            };
        } catch (error) {
            if (showError) dispatch('general/showError', null, root);
            return { ok: false, data: null, error };
        }
    },
    cancelEncounterPrescriptionInitialization() {
        prescriptionInitializationSequence += 1;
        return { ok: true, data: null, error: null, cancelled: true };
    },
    async checkForMedicalData({ dispatch, commit, rootGetters }) {
        dispatch("general/logEvent", 'checkForMedicalDataPrescription', root);
        const user = rootGetters['general/user'];
        const isVeterinaryProfessional = rootGetters['general/isVeterinaryProfessional'];
        if (!isVeterinaryProfessional || !user.cpf || !user.crmvNumber || !user.crmvState || !user.address || user.nationality) {
            dispatch('algorithms/clearNodesModelsAndInputs', null, root);
            commit('general/setConfirmModel', {
                text: _getLabel("PRESCRIPTION_MEDICAL_REGISTRATION_DETAILS"),
                callback: () => {
                    dispatch("algorithms/openAlgorithmsByModuleAndName", {
                        module: "users",
                        name: "displayNameAlgorithm",
                        children: ["displayNamePrefixAlgorithm", "cpfAlgorithm", "crmvAlgorithm", "addressAlgorithm"],
                        parent: prescriptionsRegistrationAlgorithm,
                        models: COMPLETE_REGISTRATION_MODELS,
                        args: getUserArgs(user)
                    }, root);
                },
                cancelAction: () => {
                    dispatch('general/routeBack', null, root);
                },
                confirmText: _getLabel("HAS_CRMV"),
                closeText: _getLabel("BACK"),
                persistent: true
            }, root);
            return false;
        }
        return true;
    },
    async startPrescriptionClickAction({ dispatch, commit, rootGetters, state }, { skipMedicalCheck = false } = {}) {
        dispatch("general/logEvent", 'startPrescriptionClick', root);
        let hasCompleteRegistration = true, hasPatient = true;
        if (!skipMedicalCheck) {
            hasCompleteRegistration = await dispatch('checkForMedicalData');
        }
        if (!rootGetters['patients/patient'] && hasCompleteRegistration) {
            commit("general/setConfirmModel", { alert: true, text: _getLabel('SELECT_A_PATIENT_TO_CONTINUE') }, root);
            hasPatient = false;
        }
        state.prescription = [];
        state.prescriptionId = null;
        state.patientId = rootGetters['patients/patient'] ? rootGetters['patients/patient'].id : null;
        state.encounterId = null;
        return { hasCompleteRegistration, hasPatient };
    },
    continueDrugSelectionAfterDisplayChoiceAction({ dispatch }, { item, pages, editionMode = false }) {
        const listOfNodes = item.freeText ? ADD_EDIT_FREE_TEXT_NODES : ADD_EDIT_NODES;
        let args = { pages, ...item };
        let models = null;
        if (item.freeText) {
            models = EDIT_FREE_TEXT_MODELS;
            item['freeTextNameDisplay'] = item.name;
        } else if (editionMode) {
            models = EDIT_MODELS;
        }
        dispatch("algorithms/openAlgorithmsNodes", {
            nodes: getNodesFromNames(listOfNodes, args),
            args: { pages, ...item },
            models
        }, root);
    },
    addFreeTextDrugAction({ dispatch }, { pages }) {
        dispatch("general/logEvent", 'addFreeTextDrugPrescription', root);
        const args = { freeText: true, pages, page: 0 };
        dispatch("algorithms/openAlgorithmsNodes", {
            nodes: getNodesFromNames(ADD_EDIT_FREE_TEXT_NODES, args),
            args
        }, root);

    },
    async filterDrugsFromSearchAction({ dispatch }, { search, filter }) {
        dispatch("general/logEvent", 'filterDrugsFromSearchPrescription', root);
        search = _removeAccents((search || '').toLowerCase());
        if (!search) {
            return [];
        }
        return await prescriptionsServices.postSearchForPrescriptionAvailableItems(search, filter);
    },
    async getItemDosesAndOptionsAction({ dispatch }, { item }) {
        return await dispatch('general/loadingHandler', {
            logEventArgs: 'getItemDosesAndOptionsPrescription',
            action: async () => {
                let id = null, doses = null, category = null;
                if (item.drugsList) {
                    if (typeof item.drugsList === 'string') {
                        item.drugsList = JSON.parse(item.drugsList);
                    }
                    const drugsList = item.drugsList.filter(i => !!i.drugId);
                    id = drugsList.length === 1 ? drugsList[0].drugId : null;
                    category = drugsList.length === 1 ? (drugsList[0].drugCategory || drugsList[0].category) : null;
                } else if (item.drugId) {
                    id = item.drugId;
                    category = item.drugCategory;
                }
                if (id) {
                    const response = await dispatch('drugs/getCategoryItem', { id, category }, root);
                    doses = response.doses.map(({ route, title, frequency, frequencyUnit, dose, measurement, animals, description }, index) => {
                        return {
                            description,
                            route,
                            id: index,
                            title,
                            frequency,
                            frequencyUnit,
                            dose,
                            measurement,
                            animals,
                        };
                    });
                }
                return { doses, options: [] };
            },
            errorAction: (error) => {
                dispatch(
                    "general/showError",
                    'Não foi possível buscar os dados para o medicamento selecionado. Por favor, tente novamente mais tarde.',
                    root);
                throw error;
            }
        }, root);
    },
    clearPrescriptionAction({ commit }) {
        commit('resetPrescriptionState');
    },
    async deletePrescriptionDraftAction({ state, commit, dispatch }, { callback }) {
        commit('general/setConfirmModel', {
            text: _getLabel("DELETE_DRAFT_CONFIRM"),
            callback: async () => {
                await dispatch('general/loadingHandler', {
                    logEventArgs: 'deletePrescriptionDraft',
                    action: async () => {
                        if (state.prescriptionId) {
                            await prescriptionsServices.deletePrescriptionDraft(
                                state.prescriptionId,
                                state.revision
                            );
                        }
                        await dispatch('clearPrescriptionAction');
                        callback();
                    }
                }, root);
            },
            confirmText: _getLabel("DELETE_DRAFT_CONFIRM_ACTION"),
            closeText: _getLabel("CANCEL"),
        }, root);
    },
    async openPrescriptionFromPatientAction({ dispatch, rootGetters }, prescription) {
        dispatch("general/logEvent", 'openPrescriptionFromPatient', root);
        const patient = rootGetters['patients/patient'];
        const initialized = await dispatch('initializeEncounterPrescriptionAction', {
            patientId: prescription.patientId || (patient && patient.id),
            encounterId: prescription.encounterId || null,
            prescriptionId: prescription.id,
            prescription
        });
        if (!initialized || !initialized.ok) return initialized;
        if (prescription.shareDate) {
            dispatch("general/routePathRedirect", {
                path: `/prescriptions/${prescription.id}`
            }, root);
        } else {
            dispatch("general/routePathRedirect", {
                path: `/prescriptions/${prescription.id}/edit`
            }, root);
        }
        return initialized;
    },
    async updateDraftFromPrescriptionAction({ state, dispatch, rootGetters }) {
        if (state.shareDate) {
            const hasChangedIssuedPrescription = JSON.stringify(state.prescription || [])
                !== JSON.stringify(state.issuedPagesSnapshot || []);
            if (hasChangedIssuedPrescription) {
                return {
                    ok: false,
                    data: null,
                    error: new Error('Uma receita emitida não pode ser alterada.')
                };
            }
            return {
                ok: true,
                data: { id: state.prescriptionId, revision: state.revision, immutable: true },
                error: null
            };
        }
        if (state.contextSelectionRequired && state.encounterId && !state.prescriptionId) {
            // A consulta pode ser salva sem escolher uma receita existente. Esse
            // no-op nunca envia ou altera documentos já vinculados à consulta.
            return { ok: true, data: { skipped: true, selectionRequired: true }, error: null };
        }
        return await dispatch('general/loadingHandler', {
            logEventArgs: 'updateDraftFromPrescription',
            action: async () => {
                const selectedPatient = rootGetters['patients/patient'];
                const patientId = state.patientId || (selectedPatient && selectedPatient.id);
                if (!patientId) return { ok: false, data: null, error: null };
                const saved = await prescriptionsServices.savePrescriptionDraft({
                    pages: state.prescription,
                    id: state.prescriptionId || undefined,
                    expectedRevision: state.prescriptionId ? state.revision : undefined,
                    ownerId: selectedPatient && selectedPatient.ownerId,
                    patientId,
                    encounterId: state.encounterId || undefined
                });
                const { pages, id, revision } = saved;
                state.prescriptionId = id;
                state.prescription = pages;
                state.revision = revision;
                state.patientId = patientId;
                return { ok: true, data: { pages, id, revision }, error: null };
            },
            errorAction: prescriptionErrorAction(dispatch)
        }, root);
    },
    async goToPrescriptionsDraftEditionAction({ dispatch, state }) {
        dispatch("general/logEvent", 'goToPrescriptionsDraftEdition', root);
        if (state.prescriptionId) {
            dispatch("general/routePathRedirect", {
                path: `/prescriptions/${state.prescriptionId}/edit`
            }, root);
        } else {
            dispatch("general/routePathRedirect", { path: '/prescriptions' }, root);
        }
    },
    async goToPrescriptionsSummaryAction({ dispatch, state }, updateDraft = true) {
        return await dispatch('general/loadingHandler', {
            logEventArgs: 'goToPrescriptionsSummary',
            action: async () => {
                if (updateDraft) {
                    const result = await dispatch('updateDraftFromPrescriptionAction');
                    if (!result || !result.ok) return result || { ok: false, error: null };
                }
                if (!state.prescriptionId) return { ok: false, error: null };
                dispatch("general/routePathRedirect", {
                    path: '/prescriptions/' + state.prescriptionId
                }, root);
                return { ok: true, data: { id: state.prescriptionId }, error: null };
            }
        }, root);
    },
    async getPrescriptionDetailsAndGenFilesAction({ dispatch, state, commit }, { prescriptionId, hasShareDate = false }) {
        return await dispatch('general/loadingHandler', {
            logEventArgs: 'updateDraftFromPrescription',
            action: async () => {
                if (state.prescriptionId !== prescriptionId || state.revision === null) {
                    const current = await prescriptionsServices.getPrescriptionById(prescriptionId);
                    commit('hydratePrescription', current);
                }
                const { prescription, owner, patient } = await prescriptionsServices.generatePrescriptionFiles({
                    prescriptionId,
                    issue: hasShareDate,
                    expectedRevision: state.revision
                });
                const { pages, id, files, shareDate, professionalSnapshot, revision } = prescription
                state.shareDate = shareDate;
                state.issuedPagesSnapshot = shareDate
                    ? JSON.parse(JSON.stringify(pages || []))
                    : null;
                state.prescriptionId = id;
                state.prescription = pages;
                state.files = [...files];
                state.patientId = patient.id;
                state.encounterId = prescription.encounterId || null;
                state.professionalSnapshot = professionalSnapshot || null;
                state.revision = revision;
                commit('patients/setOwner', owner, root);
                return { ok: true, data: { patient, prescription: pages, document: prescription }, patient, prescription: pages };
            },
            errorAction: prescriptionErrorAction(dispatch)
        }, root);
    },
    async getAvailableClinicalHandoutsAction({ dispatch, state }) {
        await dispatch('general/loadingHandler', {
            logEventArgs: 'getAvailableClinicalHandouts',
            action: async () => {
                let handouts = await dispatch('topics/openTopic', 'clinical_handouts', root);
                let drugIdsList = [];
                state.prescription.forEach((page) => {
                    page.forEach((item) => {
                        if (item.drugsList) {
                            drugIdsList = drugIdsList.concat(item.drugsList.map(({ drugId }) => (drugId || '').trim()).filter(d => !!d));
                        }
                    });
                });
                handouts = handouts.filter((handout) => drugIdsList.includes(handout.id));
                state.clinicalHandouts = handouts;
            },
            errorAction: (error) => {
                console.log(error);
            }
        }, root);
    },
    async postPrescriptionShareAction({ dispatch, state, rootGetters }, { type, clinicalHandouts, email, phone }) {
        await dispatch('general/loadingHandler', {
            logEventArgs: 'postPrescriptionShare',
            action: async () => {
                const doctorName = rootGetters['general/user'].displayName;
                const doctorNamePrefix = rootGetters['general/user'].displayNamePrefix;
                email = email || rootGetters['patients/owner'].email;
                phone = phone || rootGetters['patients/owner'].phone;
                const { link } = await prescriptionsServices.postPrescriptionShare({
                    prescriptionId: state.prescriptionId,
                    types: [type],
                    clinicalHandouts,
                    doctorName,
                    doctorNamePrefix,
                    email,
                    phone,
                    date: new Date().toLocaleString("pt-BR")
                });
                const SHARE_ACTIONS = {
                    EMAIL: 2,
                    WHATSAPP: 3,
                    COPY: 5,
                };
                if (type === SHARE_ACTIONS.WHATSAPP) {
                    phone = phone.replace(/[\s().+-]/g, '');
                    const encodedText = encodeURIComponent(`${doctorNamePrefix ? doctorNamePrefix + ' ' : ''}${doctorName} enviou sua prescrição. Acesse pelo link: ${link}`);
                    dispatch("general/openWhatsapp", {
                        phone,
                        text: encodedText
                    }, root);
                } else if (type === SHARE_ACTIONS.EMAIL) {
                    dispatch("general/showMessage", null, root);
                } else if (type === SHARE_ACTIONS.COPY) {
                    dispatch("general/copyToClipboard", link, root);
                }
            },
            errorAction: (error) => {
                dispatch("general/showError", 'Não foi possível compartilhar a prescrição. Por favor, tente novamente mais tarde.', root);
                throw error;
            }
        }, root);
    },
    async repeatPrescriptionAction({ dispatch, state, commit }, { patient, prescription }) {
        await dispatch('general/loadingHandler', {
            logEventArgs: 'repeatPrescription',
            action: async () => {
                commit('patients/setPatient', patient, root);
                commit('patients/setOwner', null, root);
                state.prescription = prescription;
                state.prescriptionId = null;
                state.patientId = patient.id;
                state.encounterId = null;
                state.shareDate = null;
                state.issuedPagesSnapshot = null;
                state.files = [];
                state.professionalSnapshot = null;
                state.initialized = true;
                dispatch('general/routePathRedirect', { path: '/prescriptions' }, root);
                return { ok: true, data: { patientId: patient.id }, error: null };
            }
        }, root);
    },
    async changePrescriptionsPatientAction({ state, commit, dispatch }) {
        if (state.prescription.length > 0) {
            commit('general/setConfirmModel', {
                text: 'Você tem uma prescrição em andamento. Deseja repetir a prescrição atual ou começar uma nova? <br><br> <b>Atenção:</b> Se você optar por repetir a prescrição atual, revise a posologia dos itens escolhidos.',
                callback: () => {
                    state.prescriptionId = null;
                    dispatch('updateDraftFromPrescriptionAction');
                },
                cancelAction: () => {
                    dispatch('clearPrescriptionAction');
                },
                confirmText: _getLabel("REPEAT_PRESCRIPTION"),
                closeText: _getLabel("NEW_PRESCRIPTION"),
                persistent: true
            }, root)
            return true;
        } else if (state.prescriptionId) {
            dispatch('clearPrescriptionAction');
        }
        return false;
    },
    async openProductInformationAction({ dispatch }, product) {
        dispatch('general/logEvent', 'openProductInformationPrescription', root);
        if (product.type === 1) {
            const id = product.id.split('_index_')[0];
            dispatch('general/routePathRedirect', {
                path: `/categories/${product.drugCategory}/products/${id}`,
            }, root);
        } else if (product.type === 2) {
            dispatch("general/openExternalUrl", {
                url: process.env.VUE_APP_ANVISA_INFORMATION_URL + product.id.trim(),
                inAppBrowser: true
            }, root);
        }
    }
}
